module.exports = "/static/Images/es/Neutral.png";